import Vue from 'vue';
import Vuex from 'vuex';
import moduleBuilder from '@/store/module-builder';

Vue.use(Vuex);

export const root = moduleBuilder()
  .state({})
  .defaultMutations()
  .actions({})
  .hideMutations()
  .createStore();

export default root.store;
